<script>
    import Select from "svelte-select";
    import {
        languages,
        setLanguage1,
        setLanguage2,
        selectedLanguage1,
        selectedLanguage2,
    } from "../services/store";
    import { _ } from "svelte-i18n";

    let allLanguages, languages1, languages2;

    const unsubscribe = languages.subscribe((value) => {
        if (value) {
            allLanguages = value.map((lang) => {
                lang.label = $_(`languages.${lang.value}`);
                return lang;
            });
            languages1 = allLanguages;
            languages2 = allLanguages;
        }
    });
    function handleSelect(event) {
        // remove language in other array
        languages2 = allLanguages.filter((lang) => {
            return lang.value !== event.detail.value;
        });
        let lang = allLanguages.find(
            (language) => language.value === event.detail.value
        );

        setLanguage1(lang);
    }
    function handleSelect2(event) {
        languages1 = allLanguages.filter((lang) => {
            return lang.value !== event.detail.value;
        });
        let lang = allLanguages.find(
            (language) => language.value === event.detail.value
        );

        setLanguage2(lang);
    }
    function handleClear() {
        languages2 = allLanguages;
        setLanguage1(null);
    }
    function handleClear2() {
        languages1 = allLanguages;
        setLanguage2(null);
    }
</script>

<style>
    .themed {
        --placeholderColor: #34d399;
        --borderFocusColor: black;
        --itemIsActiveBG: #fbbf24;
        --itemIsActiveColor: white;
        --itemHoverBG: #34d399;
        --height: 32px;
    }
</style>

<li class="w-32 themed ">
    <Select
        placeholder={$_('language_select.first')}
        on:select={handleSelect}
        on:clear={handleClear}
        bind:selectedValue={$selectedLanguage1}
        items={languages1} />
</li>

<li class="w-32 themed ">
    <Select
        placeholder={$_('language_select.second')}
        on:select={handleSelect2}
        on:clear={handleClear2}
        bind:selectedValue={$selectedLanguage2}
        items={languages2} />
</li>
